import { Button, Flex, Icon, SegmentedRadioGroup } from "@gravity-ui/uikit";
import { isSourceCode, SOURCE_LIST, SourceCode } from "src/constants/sources";

export interface SourcePickerProps {
  value: SourceCode | null;
  onChange: (source: SourceCode | null) => void;
  variant?: "buttons" | "segmented";
  sources?: SourceCode[];
  disabledSources?: SourceCode[];
  disabledHint?: string;
  allowDeselect?: boolean;
  stretch?: boolean;
}

export const SourcePicker = ({
  value,
  onChange,
  variant = "segmented",
  sources,
  disabledSources,
  disabledHint,
  allowDeselect = false,
  stretch = false,
}: SourcePickerProps) => {
  const isDisabled = (code: SourceCode) => !!disabledSources?.includes(code);
  const items = sources
    ? SOURCE_LIST.filter((source) => sources.includes(source.code))
    : SOURCE_LIST;

  if (!items.length) {
    return null;
  }

  if (variant === "buttons") {
    return (
      <Flex direction="row" gap="2" wrap>
        {items.map(({ code, label, Icon: SourceLogo }) => (
          <Button
            key={code}
            width={stretch ? "max" : undefined}
            selected={code === value}
            disabled={isDisabled(code)}
            title={isDisabled(code) ? disabledHint : undefined}
            size="l"
            onClick={() =>
              onChange(allowDeselect && code === value ? null : code)
            }
          >
            <Icon data={SourceLogo} size={20} />
            {label}
          </Button>
        ))}
      </Flex>
    );
  }

  return (
    <SegmentedRadioGroup
      size="l"
      width={stretch ? "max" : undefined}
      value={value ?? undefined}
      onUpdate={(next) => {
        if (isSourceCode(next)) {
          onChange(next);
        }
      }}
    >
      {items.map(({ code, label, Icon: SourceLogo }) => (
        <SegmentedRadioGroup.Option
          key={code}
          value={code}
          disabled={isDisabled(code)}
          title={isDisabled(code) ? disabledHint : label}
        >
          <Flex direction="row" gap="2" alignItems="center">
            <Icon data={SourceLogo} size={16} />
            {label}
          </Flex>
        </SegmentedRadioGroup.Option>
      ))}
    </SegmentedRadioGroup>
  );
};
